import { List } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { getAllNotificationsContent } from "../../../state/ducks/notification/operations";
import { localized } from "../../../state/i18n/i18n";
import { AppState } from "../../../state/store";
import NotificationBlock from "./notification-block";
import "./notification-list.scss";
import "../../pages/notification-settings-page/notification-settings-page.scss";

const mapStateToProps = (state: AppState) => {
  return {
    notifications: state.notificationReducer.notifications,
    pendingStatus: state.notificationReducer.pending,
    retrivalStatus: state.notificationReducer.notificationRetrivalFailed,
    emptyList: state.notificationReducer.emptyNotificationList,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchNotifications: async () =>
    (await getAllNotificationsContent())(dispatch),
});

type Props = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>;

export class NotificationList extends PureComponent<Props> {
  constructor(props: Props) {
    super(props);

    props.fetchNotifications();
  }

  private dataIsPending = () => {
    if (this.props.pendingStatus === true) {
      return (
        <div className="spinner">
          <CircularProgress />
        </div>
      );
    }
  };
  private getNotifications = () => {
    if (this.props.notifications.length > 0) {
      return this.props.notifications.map((notification) => (
        <NotificationBlock key={notification.id} id={notification.id} />
      ));
    } else if (
      this.props.retrivalStatus === false &&
      this.props.emptyList === false
    ) {
      return (
        <div className="emptyMessageNotifications">
          {localized("LoadingNotifications")}
        </div>
      );
    } else
      return (
        <div className="emptyMessageNotifications">
          {localized("NoNotifications")}
        </div>
      );
  };

  public render() {
    return (
      <List>
        <div>{this.dataIsPending()}</div>
        {this.getNotifications()}
      </List>
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(NotificationList);
